<ng-container *transloco="let t;">
  <p-dialog header="{{ t('partials.employee_search.topline') }}" [(visible)]="searchOpened" [draggable]="false"
    [resizable]="false" modal="true" [style]="{width: '80vw'}" (onHide)="close()">

    <form (submit)="onSubmit()" novalidate>
      <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-10">
          <app-form-control [cid]="'keywords'" [control]="form.get('keywords')" [type]="'input'" [showLabel]="false" [placeholder]="t('partials.employee_search.placeholder')"></app-form-control>
        </div>
        <div class="p-col-12 p-md-2">
          <button pButton type="submit" [label]="t('common.labels.search')" icon="pi pi-search" [disabled]="(loading === true) ? true : null"></button>
        </div>
      </div>
    </form>

    <p-messages [(value)]="messages" [key]="'employees'"></p-messages>

    <p *ngIf="employees.length > 0 && employees.length < maxResultLength" [innerHtml]="t('partials.employee_search.results_found', {value: employees.length})"></p>

    <p-table #table *ngIf="searchResult === true" [value]="employees" [paginator]="true" [rows]="10" sortField="lastname">
      <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="lastname">{{ t('common.labels.lastname') }}
              <p-sortIcon field="lastname"></p-sortIcon>
            </th>
            <th pSortableColumn="firstname">{{ t('common.labels.firstname') }}
                <p-sortIcon field="firstname"></p-sortIcon>
            </th>
            <th pSortableColumn="email">{{ t('common.labels.email') }}
                <p-sortIcon field="email"></p-sortIcon>
            </th>
            <th pSortableColumn="phone">{{ t('common.labels.phone') }}
                <p-sortIcon field="phone"></p-sortIcon>
            </th>
            <th pSortableColumn="mobile">{{ t('common.labels.mobile') }}
                <p-sortIcon field="mobile"></p-sortIcon>
            </th>
            <th pSortableColumn="company">{{ t('common.labels.company') }}
                <p-sortIcon field="company"></p-sortIcon>
            </th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-employee>
          <tr (click)="onSelect(employee)" (keyup.enter)="onSelect(employee)" class="tr-hover with-text-markers" tabindex="0">
            <td><span role="link" [innerHtml]="employee.lastname | dashWhenEmpty | textMark: markerText"></span></td>
            <td><span role="link" [innerHtml]="employee.firstname | dashWhenEmpty | textMark: markerText"></span></td>
            <td><span role="link" [innerHtml]="employee.email | dashWhenEmpty | textMark: markerText"></span></td>
            <td><span role="link" [innerHtml]="employee.phone | dashWhenEmpty | textMark: markerText"></span></td>
            <td><span role="link" [innerHtml]="employee.mobile | dashWhenEmpty | textMark: markerText"></span></td>
            <td><span role="link" [innerHtml]="employee.company | dashWhenEmpty | textMark: markerText"></span></td>
          </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="no-data" colspan="6">{{ t('common.labels.no_data') }}</td>
        </tr>
      </ng-template>
    </p-table>

  </p-dialog>
</ng-container>
